import { Injectable, Injector } from '@angular/core';

export enum LocalStorageKeys {
  ti_modal_email_dialog = 'ti_modal_email_dialog',
  ti_modal_send_email_dialog = 'ti_modal_send_email_dialog',
  ti_modal_choose_email_recipients = 'ti_modal_choose_email_recipients',
  ti_modal_reassign_reviewers = 'ti_modal_reassign_reviewers',
  ti_modal_set_legal_hold = 'ti_modal_set_legal_hold',
  ti_modal_release_legal_hold = 'ti_modal_release_legal_hold',
  ti_modal_essential_documents_export = 'ti_modal_essential_documents_export',
  ti_modal_documents_compare = 'ti_modal_documents_compare',
  ti_modal_export_rooms = 'ti_modal_export_rooms',
  ti_theme_colors = 'ti_theme_color',
  ti_modal_metadata_fields_list = 'ti_modal_metadata_fields_list',
  ti_modal_document_version_info = 'ti_modal_document_version_info',
  ti_modal_activity_attachment_viewer = 'ti_modal_activity_attachment_viewer',
  ti_modal_document_wizard = 'ti_modal_document_wizard',
  ti_modal_relevant_documents_wizard = 'ti_modal_relevant_documents_wizard',
  ti_modal_manage_security = 'ti_modal_manage_security',
  ti_modal_faq_create = 'ti_modal_faq_create',
  ti_modal_faq_question = 'ti_modal_faq_question',
  ti_modal_documents_history = 'ti_modal_documents_history',
  ti_modal_translations_history = 'ti_modal_translations_history',
  ti_modal_document_workflow_history = 'ti_modal_documents_workflow_history',
  ti_modal_qa_view = 'ti_modal_qa_view',
  ti_modal_convert_to_faq = 'ti_modal_convert_to_faq',
  ti_modal_export_messages = 'ti_modal_export_messages',
  ti_modal_regulatory_review = 'ti_modal_regulatory_review',
  ti_modal_mass_coding = 'ti_modal_mass_coding',
  ti_modal_resolve_query = 'ti_modal_resolve_query',
  ti_modal_document_workflow_management = 'ti_modal_document_workflow_management',
  ti_modal_user_preferences = 'ti_modal_user_preferences',
  ti_modal_replace_attachment_add_url = 'ti_modal_replace_attachment_add_url',
  ti_modal_query_history = 'ti_modal_query_history',
  ti_modal_program_profile_wizard = 'ti_modal_program_profile_wizard',
  ti_modal_create_answer = 'ti_modal_create_answer',
  ti_modal_document_workflow_release = 'ti_modal_document_workflow_release',
  ti_modal_document_workflow_exclude = 'ti_modal_document_workflow_exclude',
  ti_modal_contact_support = 'ti_modal_contact_support',
  ti_modal_document_workflow_claim = 'ti_modal_document_workflow_claim',
  ti_modal_provide_password = 'ti_modal_provide_password',
  ti_modal_module_switcher_customize = 'ti_modal_module_switcher_customize',
  ti_modal_ask_question = 'ti_modal_ask_question',
  ti_modal_group_dialog = 'ti_modal_group_dialog',
  ti_modal_not_applicable = 'ti_modal_not_applicable',
  ti_modal_set_version_question = 'ti_modal_set_version_question',
  ti_modal_approval = 'ti_modal_approval',
  ti_modal_select_inv_sites = 'ti_modal_select_inv_sites',
  ti_modal_select_template = 'ti_modal_select_template',
  ti_modal_select_risks_levels = 'ti_modal_select_risks_levels',
  ti_modal_select_irb = 'ti_modal_select_irb',
  ti_modal_delete_group = 'ti_modal_delete_group',
  ti_modal_child_groups = 'ti_modal_child_groups',
  ti_modal_users_grid = 'ti_modal_users_grid',
  ti_modal_regular_invite_form = 'ti_modal_regular_invite_form',
  ti_modal_quick_invite_form = 'ti_modal_quick_invite_form',
  ti_modal_select_list = 'ti_modal_select_list',
  ti_modal_site_wizard = 'ti_modal_site_wizard',
  ti_modal_add_to_workflow = 'ti_modal_add_to_workflow',
  ti_modal_export_settings = 'ti_modal_export_settings',
  ti_modal_export_result = 'ti_modal_export_result',
  ti_modal_delete_qa = 'ti_modal_delete_qa',
  ti_modal_background_job_result = 'ti_modal_background_job_result',
  ti_modal_document_workflow_change_status = 'ti_modal_document_workflow_change_status',
  ti_modal_document_set_starting_version = 'ti_modal_document_set_starting_version',
  ti_modal_rooms_list_dialog = 'ti_modal_rooms_list_dialog',
  ti_modal_collaborate_review_participants = 'ti_modal_collaborate_review_participants',
  ti_modal_create_new_review = 'ti_modal_create_new_review',
  ti_modal_add_existing_users = 'ti_modal_add_existing_users',
  ti_modal_task_manager = 'ti_modal_task_manager',
  ti_modal_translation_request = 'ti_modal_translation_request',
  ti_modal_create_audit_profile = 'ti_modal_create_audit_profile',
  ti_modal_reset_password = 'ti_modal_reset_password',
  ti_modal_change_access = 'ti_modal_change_access',
  ti_modal_print_barcode = 'ti_modal_print_barcode',
  ti_modal_errors_grid = 'ti_modal_errors_grid',
  ti_modal_grid_view_save = 'ti_modal_grid_view_save',
  ti_modal_change_program_status = 'ti_modal_change_program_status',
  ti_modal_exclude_from_workflows = 'ti_modal_exclude_from_workflows',
  ti_modal_program_delete = 'ti_modal_program_delete',
  ti_modal_documents_print = 'ti_modal_documents_print',
  ti_modal_create_room = 'ti_modal_create_room',
  ti_modal_bulk_invite = 'ti_modal_bulk_invite',
  ti_modal_documents_cart_review = 'ti_modal_documents_cart_review',
  ti_modal_close_room = 'ti_modal_close_room',
  ti_modal_send_for_e_signature = 'ti_modal_send_for_e_signature',
  ti_modal_add_users_groups = 'ti_modal_add_users_groups',
  ti_modal_select_audits = 'ti_modal_select_audits',
  ti_modal_share_document = 'ti_modal_share_document',
  ti_modal_convert_contacts_to_users = 'ti_modal_convert_contacts_to_users',
  ti_modal_clone_docs_to_inv_sites = 'ti_modal_clone_docs_to_inv_sites',
  ti_modal_clone_documents = 'ti_modal_clone_documents',
  ti_modal_select_audit = 'ti_modal_select_audit',
  ti_modal_select_a_submission = 'ti_modal_select_a_submission',
  ti_modal_add_to_submission_package = 'ti_modal_add_to_submission_package',
  ti_modal_modify_index = 'ti_modal_modify_index',
  ti_modal_the_index_is_locked = 'ti_modal_the_index_is_locked',
  ti_modal_errors_information = 'ti_modal_errors_information',
  ti_modal_bulk_upload = 'ti_modal_bulk_upload',
  ti_modal_ocr = 'ti_modal_ocr',
  ti_modal_room_treeview = 'ti_modal_room_treeview',
  ti_modal_create_project_link = 'ti_modal_create_project_link',
  ti_modal_document = 'ti_modal_document',
  ti_modal_dashboard_setup = 'ti_modal_dashboard_setup',
  ti_modal_duplicated_contact_name = 'ti_modal_duplicated_contact_name',
  ti_modal_edit_comment = 'ti_modal_edit_comment',
  ti_modal_selection_room_template = 'ti_modal_selection_room_template',
  ti_modal_irb_list = 'ti_modal_irb_list',
  ti_modal_bullet = 'ti_modal_bullet',
  ti_modal_document_versions_viewer = 'ti_modal_document_versions_viewer',
  ti_modal_documents_versions_viewer = 'ti_modal_documents_versions_viewer',
  ti_modal_layout_switcher = 'ti_modal_layout_switcher',
  ti_modal_add_contact = 'ti_modal_add_contact',
  ti_modal_edit_contact = 'ti_modal_edit_contact',
  ti_modal_grid_share = 'ti_modal_grid_share',
  ti_modal_grid_columns_configuration = 'ti_modal_grid_columns_configuration',
  ti_modal_grid_query_save = 'ti_modal_grid_query_save',
  ti_modal_view_security = 'ti_modal_view_security',
  ti_modal_site_view_security = 'ti_modal_site_view_security',
  ti_modal_new_organization = 'ti_modal_new_organization',
  ti_modal_documents_cart_confirmation = 'ti_modal_documents_cart_confirmation',
  ti_modal_select_doc_types = 'ti_modal_select_doc_types',
  ti_modal_selected_audits_info = 'ti_modal_selected_audits_info',
  ti_modal_export_topics = 'ti_modal_export_topics',
  ti_modal_select_folders = 'ti_modal_select_folders',
  ti_modal_check_in = 'ti_modal_check_in',
  ti_modal_check_out = 'ti_modal_check_out',
  ti_modal_about_this_room = 'ti_modal_about_this_room',
  ti_modal_set_legal_hold_action = 'ti_modal_set_legal_hold_action',
  ti_modal_unpublish_confirmation = 'ti_modal_unpublish_confirmation',
  ti_modal_reason_to_unpublish = 'ti_modal_reason_to_unpublish',
  ti_modal_add_existing_users_rooms = 'ti_modal_add_existing_users_rooms',
  ti_modal_clone_docs_to_inv_sites_specific = 'ti_modal_clone_docs_to_inv_sites_specific',
  ti_modal_clone_docs_to_inv_sites_selection = 'ti_modal_clone_docs_to_inv_sites_selection',
  ti_modal_release_legal_hold_action = 'ti_modal_release_legal_hold_action',
  ti_modal_add_existing_users_action = 'ti_modal_add_existing_users_action',
  ti_modal_iframe_content = 'ti_modal_iframe_content',
  ti_modal_close_review_session = 'ti_modal_close_reviw_session',
  ti_modal_prompt = 'ti_modal_prompt',
  ti_modal_question = 'ti_modal_question',
  ti_modal_move_to_etmf = 'ti_modal_move_to_etmf',
  ti_modal_documents_assign_to = 'ti_modal_documents_assign_to',
  ti_modal_simple_credentials_prompt = 'ti_modal_simple_credentials_prompt',
  ti_modal_adobe_sign_window_prompt = 'ti_modal_adobe_sign_window_prompt',
  ti_modal_common_wizard_data = 'ti_modal_common_wizard_data',
  ti_modal_faq_send_mail = 'ti_modal_faq_send_mail',
  ti_modal_document_viewer_modal = 'ti_modal_document_viewer_modal',
  ti_modal_document_details = 'ti_modal_document_details',
  ti_modal_about_ti = 'ti_modal_about_ti',
  ti_cache_enabled = 'ti_cache_enabled',
  ti_modal_manage_mfa = 'ti_modal_manage_mfa',
  ti_modal_edit_placeholder = 'ti_modal_edit_placeholder',
  ti_modal_true_copy_cert = 'ti_modal_true_copy_cert',
  ti_component_document_coding = 'ti_component_document_coding',
  ti_modal_merge_documents = 'ti_modal_merge_documents',
  ti_modal_site_manage_security = 'ti_modal_site_manage_security',
  ti_modal_site_manage_security_option = 'ti_modal_site_manage_security_option',
  ti_documents_cart_window = 'ti_documents_cart_window',
  ti_entity_cart_window = 'ti_entity_cart_window',
  ti_modal_document_restore_errors = 'ti_modal_document_restore_errors',
  ti_modal_document_duplicate = 'ti_modal_document_duplicate',
  ti_modal_document_versions = 'ti_modal_document_versions',
  ti_idle_timer_alert_text = 'ti_idle_timer_alert_text',
  ti_modal_create_edit_responsible_department = 'ti_modal_create_edit_responsible_department',
  ti_modal_respond_to_query = 'ti_modal_respond_to_query',
  ti_modal_email_recipients = 'ti_modal_email_recipients',
  ti_url_before_expiration = 'ti_url_before_expiration',
  ti_modal_new_event = 'ti_modal_new_event',
  ti_modal_set_search_query = 'ti_modal_set_search_query',
  ti_modal_site_documents_data = 'ti_modal_site_documents_data',
  ti_modal_create_edit_event_type = 'ti_modal_create_edit_event_type',
  ti_modal_add_existing_event_type = 'ti_modal_add_existing_event_type',
  ti_modal_study_profile_wizard = 'ti_modal_study_profile_wizard',
  ti_modal_password_recovery_setup = 'ti_modal_password_recovery_setup',
  ti_last_user_id = 'ti_last_user_id',
  ti_modal_delete_site = 'ti_modal_delete_site',
  ti_modal_esignature_process_details = 'ti_modal_esignature_process_details',
  ti_modal_reject_process_details = 'ti_modal_reject_process_details',
  ti_modal_study_profile_add_room = 'ti_modal_study_profile_add_room',
  ti_modal_add_event_trigger = 'ti_modal_add_event_trigger',
  ti_modal_event_triggers = 'ti_modal_event_triggers',
  ti_modal_configure_autonaming = 'ti_modal_configure_autonaming',
  ti_modal_add_existing_group = 'ti_modal_add_existing_group',
  ti_modal_add_to_site = 'ti_modal_add_to_site',
  ti_modal_add_edit_site_visit = 'ti_modal_add_edit_site_visit',
  ti_modal_approve_or_reject_document = 'ti_modal_approve_or_reject_document',
  ti_modal_ssu_contact_activities = 'ti_modal_ssu_contact_activities',
  ti_modal_ssu_contact_mass_codding = 'ti_modal_ssu_contact_mass_codding',
  ti_modal_study_profile_change_status = 'ti_modal_study_profile_change_status',
  ti_modal_add_budgets_and_contracts = 'ti_modal_add_budgets_and_contracts',
  ti_modal_ssu_bulk_upload = 'ti_modal_ssu_bulk_upload',
  ti_modal_add_edit_country = 'ti_modal_add_edit_country',
  ti_modal_ssu_delete_documents = 'ti_modal_ssu_delete_documents',
  ti_modal_cart_page_add_to_submission_package = 'ti_modal_cart_page_add_to_submission_package',
  ti_modal_ssu_approve_reject_doc = 'ti_modal_ssu_approve_reject_doc',
  ti_modal_ssu_add_replace_doc = 'ti_modal_ssu_add_replace_doc',
  ti_modal_document_audit_change_status = 'ti_modal_document_audit_change_status',
  ti_modal_resolve_document_conflict = 'ti_modal_resolve_document_conflict',
  ti_modal_progress = 'ti_modal_progress',
  ti_modal_add_existing_organizations = 'ti_modal_add_existing_organizations',
  ti_modal_oo_comments = 'ti_modal_oo_comments',
  ti_modal_oo_compare = 'ti_modal_oo_compare',
  ti_modal_convert_contact_form = 'ti_modal_convert_contact_form',
  ti_modal_convert_contact_to_user = 'ti_modal_convert_contact_to_user',
  ti_hotfix_index = 'ti_hotfix_index',
  ti_modal_assign_to_placeholder = 'ti_modal_assign_to_placeholder',
  ti_session_expired = 'ti_session_expired',
  staging_folder_warning = 'staging_folder_warning',
  ti_module_switcher_onboarding_dismissed = 'ti_module_switcher_onboarding_dismissed',
}

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  readonly keys = LocalStorageKeys;

  getItem(key: LocalStorageKeys, def = null): string | null {
    return localStorage.getItem(key) || def;
  }

  setItem(key: LocalStorageKeys, value) {
    localStorage.setItem(key, value);
  }

  removeItem(key: LocalStorageKeys) {
    localStorage.removeItem(key);
  }

  hasItem(key: LocalStorageKeys) {
    return localStorage.getItem(key) !== null;
  }
}

export const localStorageService = Injector.create({ providers: [{ provide: LocalStorageService, deps: [] }] }).get(
  LocalStorageService,
);
